import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IOccupation {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  managersDirectorsOfficials?: number | null;
  professionalOccupations?: number | null;
  associateProfessionalTechnical?: number | null;
  administrativeSecretarial?: number | null;
  skilledTradesOccupations?: number | null;
  caringLeisureService?: number | null;
  salesCustomerService?: number | null;
  processPlantMachineOperatives?: number | null;
  elementaryOccupations?: number | null;
}

export const defaultValue: Readonly<IOccupation> = {};
